import Coa4Actions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperCoa4:null,
  errorInternal:false
};

function Coa4Reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Coa4Actions.RESET_LIST:
      return INITIAL_STATE;
    case Coa4Actions.NEW_DATA:
      return { ...state,errorInternal:false,  errorMessage: [],onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case Coa4Actions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case Coa4Actions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,isNewRecord:false,showModal:true};
    case Coa4Actions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case Coa4Actions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case Coa4Actions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case Coa4Actions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case Coa4Actions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case Coa4Actions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case Coa4Actions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    //  case Coa4Actions.GET_HELPER_COA2:
    //    return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperCoa2:action.payload};
    case Coa4Actions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
       
    default:
      return state;
    }
}

export default Coa4Reducer;
